export default __webpack_public_path__ + "static/media/network.39878538.svg";